import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {
  ARRIVES,
  CANCELLED,
  COMPLETED,
  DELIVERED,
  IN_PROCESS,
  PARTIALLY_SHIPPED,
  RESCHEDULED,
  RETURN_COMPLETED,
  RETURN_INITIATED,
  RETURN_RECEIVED,
  SHIPPED,
} from '/enum/clientJourneyTasks.enum';
import {openURL} from '/util/linking.util';

// @ts-expect-error TS(7030): Not all code paths return a value.
export const getOrderStatusIconName = (shippingStatus: any) => {
  switch (shippingStatus) {
    case DELIVERED:
      return 'completed-delivered';
    case IN_PROCESS:
      return 'in-process';
    case SHIPPED:
    case COMPLETED:
      return 'shipped';
    case PARTIALLY_SHIPPED:
      return 'partially-shipped';
    case CANCELLED:
      return 'cancelled';
    case RETURN_INITIATED:
      return 'return';
    case RETURN_RECEIVED:
      return 'return';
    case RETURN_COMPLETED:
      return 'return';
  }
};

export const onTrackingNumberPress = (
  {popoverShow}: any,
  currentScreen: any,
  trackingUrl: any,
) => {
  return () => {
    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      destinationURL: trackingUrl,
      onSubmit: () => openURL('url', trackingUrl),
    });
  };
};

export const shouldRenderTrackingDetails = (packageStatus: any) => {
  return (
    packageStatus === DELIVERED ||
    packageStatus === SHIPPED ||
    packageStatus === ARRIVES ||
    packageStatus === RESCHEDULED
  );
};

export const getFormattedShippingStatus = (status: any) => {
  return status?.replace(/(^\w{1})|(\s+\w{1})/g, (letter: any) =>
    letter.toUpperCase(),
  );
};
